interface MinimalLogger {
  child: (options: Object) => MinimalLogger;
  trace: (...args: any[]) => void;
  debug: (...args: any[]) => void;
  info: (...args: any[]) => void;
  warn: (...args: any[]) => void;
  error: (...args: any[]) => void;
  fatal: (...args: any[]) => void;
}

class NullLogger implements MinimalLogger {
  child(_options: Object): MinimalLogger { return this; }
  trace(..._args: any[]): void {}
  debug(..._args: any[]): void {}
  info(..._args: any[]): void {}
  warn(..._args: any[]): void {}
  error(..._args: any[]): void {}
  fatal(..._args: any[]): void {}
}

export let log: MinimalLogger = new NullLogger();
export const setGlobalLogger = (_log: MinimalLogger) => { log = _log; };
